const sections = [
  {
    title: "Information we collect",
    body: "When you contact Code7s, we may collect your name, email address, project details, company information, and any message or files you choose to share. We also may collect basic website analytics such as pages visited, device type, browser type, referring pages, and approximate location derived from standard analytics tools.",
  },
  {
    title: "How we use information",
    body: "We use information to respond to inquiries, understand project requirements, provide product design and development services, improve our website, maintain security, and communicate about Code7s services or products when relevant.",
  },
  {
    title: "Product and client work",
    body: "For client projects, Code7s may process information needed to design, develop, test, launch, and support apps, websites, SaaS platforms, dashboards, ecommerce products, or internal tools. Project data is handled only for the agreed product work and support.",
  },
  {
    title: "Sharing information",
    body: "We do not sell personal information. We may share information with trusted service providers that help us operate the website, communicate with clients, host products, analyze performance, or deliver project work. We may also disclose information if required by law.",
  },
  {
    title: "Data retention",
    body: "We keep information only as long as needed for business, legal, security, and project purposes. You can request that we update or delete personal information where applicable.",
  },
  {
    title: "Your choices",
    body: "You may contact us to request access, correction, or deletion of personal information. Some records may be retained when needed for legal, accounting, security, or legitimate business reasons.",
  },
];

export default function Code7sPrivacyPolicy() {
  return (
    <main className="premium-page">
      <section className="premium-shell">
        <div className="page-hero-block">
          <p className="eyebrow">Privacy Policy</p>
          <h1 className="hero-heading mt-5">Code7s Privacy Policy.</h1>
          <p className="hero-copy">
            This policy explains how Code7s collects, uses, and protects
            information across our website, studio services, client projects,
            and products published by Code7s.
          </p>
          <p className="mt-5 text-sm font-semibold uppercase tracking-[0.18em] text-neutral-500">
            Last updated: August 18, 2026
          </p>
        </div>

        <div className="mx-auto mt-14 grid max-w-5xl gap-5">
          {sections.map((section) => (
            <section key={section.title} className="glass-card rounded-[24px] p-6 text-center">
              <h2 className="text-2xl font-extrabold tracking-tight text-neutral-950">
                {section.title}
              </h2>
              <p className="section-copy mt-4">{section.body}</p>
            </section>
          ))}
        </div>

        <section className="mx-auto mt-10 max-w-5xl text-center">
          <h2 className="section-heading mb-6">Contact</h2>
          <p className="section-copy">
            For privacy questions or requests, contact Code7s at
            code7s.official@gmail.com.
          </p>
        </section>
      </section>
    </main>
  );
}
